import { Component, OnInit, OnDestroy, HostListener, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
//import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
//import {MsalModule, MsalService,MsalGuard} from '@azure/msal-angular';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from './shared/app-constants/category-constants';
import { GraphService, ProviderOptions } from './msal-authentication/graph.service';
import { Subject } from 'rxjs-compat';
import { loginRequest, protectedResources } from './msal-authentication/auth-config';
import {  AuthenticationResult, EventMessage, EventType, InteractionType} from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { UserService } from 'src/framework/services/userservice';
import { CommonService } from 'src/framework/services/common.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  serviceList: any[] = [];
  config: any;
  authenticationContext = null;
  public userName;
  private userType: string;
  mappedlabels: any[];
  aboutrestructuringlink: string;
  languagearray: any[];
  labelValues: any;
  lablesCodes: string[];
  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  defaultLabelEnglishJson: any;
  selectedAppLabelLanguageJson: any;
  isInternalLoginRoute: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  isTokenRenewed: boolean = false;
  MappedLanguage = [];
  MappedEnglishLanguage = [];
  selectedLanguage: { name: string; };
  userActivity: any;
  userActivityAfterNotified: any;
  userInactive: Subject<any> = new Subject();
  public showConfirmation: boolean = false;
  public isUserTriggredLogout: boolean = false;
  notifiedInactiveUser: Subject<any> = new Subject();
  modalShow = false;
  public sessionReq = {
    userEmail : null,
    sessionId : null
  }


  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private msalBroadcastService: MsalBroadcastService,private commonService:CommonService,
    private router: Router,    
    private graphService: GraphService, private _userservice : UserService,
    private service: LabelcardMgmtService, private route: ActivatedRoute, private location: Location, private msalService: MsalService, private languageService: LanguageService) {
    // this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
    //   if (event.url == "/internallogin") {
     
    //   }
    // })
    // if (!this.adalSvc.) {
    // }
    // this.authenticateuser();
    if (this.msalService.instance.getActiveAccount() != null) {
      //this.resetTimer();
      this.authenticateuser();
  }
}
  ngOnInit(): void {
      this.msalBroadcastService.msalSubject$
    .pipe(
      filter(
        (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS ),
      takeUntil(this._destroying$)
    )
    .subscribe((result : EventMessage)=> {
      if(result.eventType === EventType.LOGIN_SUCCESS){
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);
        sessionStorage.setItem('msal.idtoken', payload.accessToken);
        this.commonService.setLoggedInUserObs(true);
        this.authenticateuser();
      }
    });
    this.languageService.currentData.subscribe(data => this.selectedLanguage = data);
    this.languageService.mySubject.subscribe((data) => {
      //call my function
      var languageMappings = data;
      if (languageMappings?.length > 0) {
        var selectedLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Global && item.languageId == this.selectedLanguage['Id']);
        this.MappedLanguage = JSON.parse(selectedLanguageMappings[0].languageMappingJSON);
        var englishLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Global && item.languageId == 1);
        this.MappedEnglishLanguage = JSON.parse(englishLanguageMappings[0].languageMappingJSON);
      }
    });
    this.GetAllLabels();
    this.loadLanguageLabel();
  }

  //Authenticates current logged in user
  authenticateuser(){
    if(this.msalService.instance.getActiveAccount() != null)
    {
      var currentAccount = this.msalService.instance.getActiveAccount();
      sessionStorage.setItem('userName', currentAccount.name);
      sessionStorage.setItem('userEmail', currentAccount.username);
      this.userName = currentAccount.name;
      if(sessionStorage.getItem('CurrentSession') == null || sessionStorage.getItem('CurrentSession') == undefined)
      {
         this.manageUserSession(currentAccount.username);
      }
      else{
        this.sessionReq = JSON.parse(sessionStorage.getItem('CurrentSession'));
        if(this.sessionReq){
          this._userservice.updateSessionInfo(this.sessionReq).subscribe();
          this.isTokenRenewed = true;
        }

      }
    }
  }

  private manageUserSession(userName)
  {
    console.log(userName);
     this._userservice.addSessionInfo({
      userEmail: userName,
      })
     .subscribe((response : any)=> {
      if(response && response.status == 1){
        this.sessionReq.userEmail = userName;
        this.sessionReq.sessionId= response.message;
        sessionStorage.setItem('CurrentSession', JSON.stringify(this.sessionReq));

        if(!response.data){
          this.modalShow= true;
        }
      }
     });
  }

  hideModal(response: any) {

    if (response == "Yes") {
      this.modalShow = false;
      this.refreshUserState();
      this._userservice.endOtherActiveSession(this.sessionReq).subscribe();
    } else {

      this.modalShow = false;
      this._userservice.endSessionInfo(this.sessionReq).subscribe((response: any) => {
        if (!response.data) {
          this.logout();
        }

      });
    }
  }

  @HostListener('window:mousemove')
  refreshUserState() {
    clearTimeout(this.userActivity);
    clearTimeout(this.userActivityAfterNotified);
    this.setTimeout();
    if (this.showConfirmation == true) {
      this.setTimeoutForAutoLogout();
    }
  }

  setTimeoutForAutoLogout() {
    this.userActivityAfterNotified = setTimeout(() => this.notifiedInactiveUser.next(undefined), 5 * 60 * 1000);
  }


  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 59 * 60 * 1000);
  }
  logout() {
    clearTimeout(this.userActivity);
    clearTimeout(this.userActivityAfterNotified);
    this._userservice.endSessionInfo(this.sessionReq).subscribe((response: any) => {
      if (!response.data) {
      } 
      this.showConfirmation = false;
    sessionStorage.clear();
    localStorage.clear()
    this.msalService.logout();
    this.isUserTriggredLogout = true;
    this.router.navigate["/home"];
    });
  }

  GetAllLabels() {
    this.mappedlabels = [];
    var languageId = 1;
    this.service.getAllMappedLabels(languageId)
      .subscribe
      (
        (resp) => {
          this.mappedlabels = [];
          this.languagearray = [];
          this.mappedlabels = resp;
          this.languageService.mySubject.next(this.mappedlabels);
        });
  }

  goToPreview() {
    this.aboutrestructuringlink = this.selectedAppLanguageJson['PrivacyLinkURL'] ? this.selectedAppLanguageJson['PrivacyLinkURL'] : this.defaultEnglishJson['PrivacyLinkURL'];
    window.open(this.aboutrestructuringlink);
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishLanguageLabelMappings, selectedLanguageLabelMappings: any;

    return new Promise<void>((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Links.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLanguageLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Links.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLanguageLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Links.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLanguageLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLanguageLabelMappings = englishLanguageLabelMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedAppLabelLanguageJson = JSON.parse(selectedLanguageLabelMappings.languageMappingJSON);

          this.defaultLabelEnglishJson = JSON.parse(englishLanguageLabelMappings.languageMappingJSON);
          this.islabelLoaded = true;
          resolve();
        }
        else {

        }
      });
    })
      .catch(err => {
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  titleReplacer(labelKey): string {
    return this.selectedAppLabelLanguageJson[labelKey]?.trim() ? this.selectedAppLabelLanguageJson[labelKey] ?? 'text not found' : this.defaultLabelEnglishJson[labelKey] ?? 'text not found';
  }
  ngOnDestroy(): void {

  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
      document.getElementById("eyLogo").style.height = "30px";
      document.getElementById("sticky-navbar").style.height = "53px";
      document.getElementById("eyLogo").style.marginTop = "10px";
    } else {
      document.getElementById("eyLogo").style.height = "70px";
      document.getElementById("sticky-navbar").style.height = "83px";
    }
  }
}

